import { Injectable } from "@angular/core";
import { HTTPService } from "./http.service";
import { DacConfig } from "./dac-config.service";

@Injectable()
export class StripePaymentProcessor {
    private readonly CARD_LOCALE = 'auto';

    constructor(private dac$http: HTTPService,
        private dacConfig: DacConfig) {
    }

    createToken(amount: number, description: string): Promise<any> {
        let receivedToken = false;
        return new Promise((resolve, reject) => {
            var handler = (<any>window).StripeCheckout.configure({
                key: this.dacConfig.stripe_public_key,
                locale: this.CARD_LOCALE,
                token: function (token: any) {
                    // You can access the token ID with `token.id`.
                    // Get the token ID to your server-side code for use.
                    receivedToken = true;
                    resolve(token);
                }
                , closed: function (response) {
                    console.log("response is: ", response);
                    if (!receivedToken) {
                        reject({ code: "canceled" });
                    }
                }
            });

            handler.open({
                name: this.dacConfig.stripe_charge_name,
                description: description,
                amount: amount
            });
        });
    }

    createUpdateCardToken(description:string, existingEmail?:string): Promise<any> {
        let receivedToken = false;
        return new Promise((resolve, reject) => {
            var handler = (<any>window).StripeCheckout.configure({
                key: this.dacConfig.stripe_public_key,
                locale: this.CARD_LOCALE,
                token: function (token: any) {
                    // You can access the token ID with `token.id`.
                    // Get the token ID to your server-side code for use.
                    receivedToken = true;
                    resolve(token);
                }
                , closed: function (response) {
                    console.log("response is: ", response);
                    if (!receivedToken) {
                        reject({ code: "canceled" });
                    }
                }
            });
            let options:any = {
                name: this.dacConfig.stripe_charge_name
                ,description: description
                ,panelLabel: "Save Payment Card"
                ,allowRememberMe: false
            };
            if (existingEmail) {
                options.email = existingEmail;
            }

            handler.open(options);
        })
    }

    charge(amount, description): Promise<any> {
        return this.createToken(amount, description).then((tokenCreateResponse) => {
            console.log("Response received: ", tokenCreateResponse);
            return tokenCreateResponse.id;
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/stripe-payment-processor.service.ts